import { render, staticRenderFns } from "./HistoryRecord.vue?vue&type=template&id=6f41797e&scoped=true"
import script from "./HistoryRecord.vue?vue&type=script&lang=js"
export * from "./HistoryRecord.vue?vue&type=script&lang=js"
import style0 from "./HistoryRecord.vue?vue&type=style&index=0&id=6f41797e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f41797e",
  null
  
)

export default component.exports